// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ImgResponsive":"vq_a zu_a zu_q zu_j zu_ti zu_bj","ImgResponsive__img":"vq_b zu_b zu_nt"};